import React from 'react';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

const colorMapping = {
	PAYMENT_PROCESSING: 'yellow',
	COMPLETED: 'green',
	CHEQUE_CASH: 'yellow'
};

export default hot(module)(function (props) {
	const { t } = useTranslation();
	const status = props.status;
	return (
		<Chip
			color="primary"
			label={t(`payment_status.${status}`)}
			size="small"
			style={{ backgroundColor: colorMapping[status] || 'yellow', color: 'black' }}
		/>
	);
});
